module.exports = __webpack_public_path__ + "static/img/none_new2.ec3c5f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/none_new2.png
// module id = wnxY
// module chunks = 2